export default {
    name: "Online Transaction Status",
    to: "/online/status",
    icon: 'mdi-credit-card-check',
    enabled: true,
};